import React from 'react';
import { cardSurfaceClass, circleThemes, cx } from '../theme';

function splitCircleHeading(heading) {
  const parts = String(heading || '').split(' - ');
  if (parts.length < 2) {
    return {
      eyebrow: heading,
      headline: '',
    };
  }

  return {
    eyebrow: parts[0],
    headline: parts.slice(1).join(' - '),
  };
}

export default function CirclePanelHeader({ circle }) {
  const { eyebrow, headline } = splitCircleHeading(circle.heading);

  return (
    <div className={cx(cardSurfaceClass, 'flex flex-wrap items-start justify-between gap-4 px-6 py-5 ring-1', circleThemes[circle.id].panelRing)}>
      <div className="flex items-start gap-4">
        <span className={cx('mt-1 h-10 w-1 rounded-full', circleThemes[circle.id].headerAccent)} />
        <div>
          <span data-coo="panel-heading" className="sr-only">
            {circle.heading}
          </span>
          <div className="text-[10px] font-semibold uppercase tracking-[0.1em] text-slate-400">
            {eyebrow}
          </div>
          {headline ? (
            <h2 className="mt-1 text-[20px] font-semibold tracking-[-0.02em] text-slate-900">
              {headline}
            </h2>
          ) : null}
          <div data-coo="panel-mp-summary" className="mt-2 text-[12px] text-slate-500">
            {circle.mpSummary}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {circle.scoreBadges.map((badge) => (
          <div
            key={`${circle.id}-${badge.label}`}
            data-coo="score-badge"
            className="rounded-xl border border-app-border bg-slate-50 px-3 py-2 text-left"
          >
            <span data-coo="score-badge-label" className="block text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-400">
              {badge.label}
            </span>
            <span data-coo="score-badge-value" className="mt-1 block text-[12px] font-semibold text-slate-800">
              {badge.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
